import { observer } from 'mobx-react';
import { Progress } from '../Summary/Progress';
import { summaryStore } from '../store';

export const Step1Progress = observer(() => {
    return (
        <Progress
            loading={summaryStore.isLoadingSummary}
            end={summaryStore?.paragraphs && summaryStore?.paragraphs?.length}
            desc="灵感正在帮您生成大纲，预计需要等待60s左右，请耐心等待~"
            list={['启动中...', '分析题目', '检索文献', '生成大纲']}
        />
    );
});
